import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { StarknetWalletProvider } from '../StarknetWalletProvider.types';

export const isStarknetWalletProvider = (
  provider: WalletProvider | StarknetWalletProvider
): provider is StarknetWalletProvider => {
  return provider.chain === 'STARK';
};
